import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { globalStyle, style } from '@vanilla-extract/css';

export const assetGridCheckbox = style({ opacity: 0 }, 'asset-grid-checkbox');

export const assetGridCheckboxVisible = style({ opacity: 1 }, 'asset-grid-checkbox-visible');

export const assetGridActions = style({ opacity: 0 }, 'asset-grid-actions');

export const assetGridWrapper = style(
  {
    background: themeVars.color['surface-base'],
    borderRadius: themeVars.radius['4'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
    width: '100%',
  },
  'asset-grid-wrapper',
);

globalStyle(`.${assetGridWrapper}:hover .${assetGridCheckbox}`, { opacity: 1 });
globalStyle(`.${assetGridWrapper}:focus-within .${assetGridCheckbox}`, { opacity: 1 });
globalStyle(`.${assetGridWrapper}:hover .${assetGridActions}`, { opacity: 1 });
globalStyle(`.${assetGridWrapper}:focus-within .${assetGridActions}`, { opacity: 1 });

export const assetGridFolder = style(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  'asset-grid-folder',
);

export const imagePreview = style(
  {
    borderRadius: themeVars.radius['4'],
    aspectRatio: '3 / 2',
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  'image-preview',
);

export const assetUnselectable = style({ cursor: 'not-allowed' }, 'asset-unselectable');

export const assetNotClickable = style({ cursor: 'default' }, 'asset-not-clickable');

export const assetUnselectableContent = style({ opacity: 0.3 }, 'asset-unselectable-content');

export const assetGridFolderDropping = style(
  {
    background: themeVars.color['surface-base-hover'],
    borderColor: themeVars.color['border-accent'],
  },
  'asset-grid-folder-dropping',
);

export const assetGridChecked = style(
  {
    background: themeVars.color['surface-active'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-accent']}`,
  },
  'asset-grid-checked',
);

export const folderIconGrid = style({ width: '90%' }, 'folder-icon-grid');

export const folderIconList = style({ width: '24px' }, 'folder-icon-list');

export const imagePreviewContainer = style(
  {
    borderRadius: themeVars.radius['4'],
    aspectRatio: '3 / 2',
    width: '100%',
    backgroundImage: `
      linear-gradient(45deg, #ccc 25%, transparent 25%),
      linear-gradient(135deg, #ccc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #ccc 75%),
      linear-gradient(135deg, transparent 75%, #ccc 75%)`,
    backgroundSize: '20px 20px',
    backgroundPosition: '0 0, 10px 0, 10px -10px, 0 10px',
    overflow: 'hidden',
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
    display: 'flex',
  },
  'image-preview-container',
);

globalStyle(`tr:hover .${assetGridActions}`, { opacity: 1 });
globalStyle(`tr:focus-within .${assetGridActions}`, { opacity: 1 });

export const assetListIcon = style(
  {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  'asset-list-icon',
);

export const breadcrumbDropping = style(
  {
    background: themeVars.color['surface-base-hover'],
    borderColor: themeVars.color['border-accent'],
  },
  'breadcrumb-dropping',
);

export const bodyDraggingAsset = style({}, 'body-dragging-asset');

globalStyle(`body.${bodyDraggingAsset}`, { cursor: 'grabbing !important' });
globalStyle(`body.${bodyDraggingAsset} *`, { cursor: 'grabbing !important' });

export const dragOverlayBox = style(
  {
    backgroundColor: themeVars.color['surface-base'],
    borderRadius: themeVars.radius['4'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
  },
  'drag-overlay-box',
);

export const assetsContainer = style({ minHeight: '256px' }, 'assets-container');
